const logLevelData = {
    '*': 'debug'
};

export default logLevelData;
